const presetSelect = {
    hasBuilderButton: true,
    hasNormsTab: false,
  }
  
  export default presetSelect
  export { presetSelect }
  